import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import blogPosts from './data/blogPosts';
import './SubscribePage.css';
import './ProfilePage.css';

// TODO: Replace with API call to /api/search-pages?type=profile when real advisors are onboarded
const sampleAdvisors = [
    /* Coming soon — no live advisors yet
    {
        slug: 'sarah-mitchell-sm24demo',
        type: 'individual',
        displayName: 'Dr Sarah Mitchell',
        postNominals: 'BSc, MSc, HCPC',
        headline: 'Specialist MSK physiotherapist helping patients recover from sports injuries, chronic pain, and post-operative rehabilitation',
        city: 'London',
        region: 'Greater London',
        country: 'United Kingdom',
        primarySpecialty: 'Sports Rehabilitation',
        specialties: ['Lower Back Pain', 'Knee Injuries', 'Post-operative Recovery'],
        conditionsTreated: ['Lower Back Pain', 'Knee Injuries', 'Rotator Cuff'],
        consultationTypes: ['Online', 'In-Person'],
        treatmentApproaches: ['Manual Therapy', 'Exercise Therapy', 'Shockwave Therapy'],
        acceptedPaymentMethods: ['Private', 'Insurance'],
        acceptedInsurers: ['BUPA', 'AXA Health'],
        gender: 'Female',
        acceptingNewPatients: true,
        availableEvenings: true,
        availableWeekends: false,
        freeConsultation: true,
        aggregateRating: 4.9,
        reviewCount: 127,
        hcpcVerified: true,
        cspMember: true,
        yearsExperience: 15,
        startingPrice: 35,
    },
    {
        slug: 'flexibility-matters-fm24demo',
        type: 'company',
        displayName: 'Flexibility Matters',
        postNominals: null,
        headline: 'Corporate MSK solutions for workplace wellness — ergonomic assessments, prevention programmes, and group sessions',
        city: 'Manchester',
        region: 'Greater Manchester',
        country: 'United Kingdom',
        primarySpecialty: 'Corporate Wellness',
        specialties: ['Workplace Ergonomics', 'Prevention Programs', 'Group Sessions'],
        conditionsTreated: ['Repetitive Strain', 'Neck Pain', 'Lower Back Pain'],
        consultationTypes: ['In-Person', 'Home Visit'],
        treatmentApproaches: ['Exercise Therapy', 'Pilates'],
        acceptedPaymentMethods: ['Corporate', 'Private'],
        acceptedInsurers: [],
        gender: null,
        acceptingNewPatients: true,
        availableEvenings: false,
        availableWeekends: true,
        freeConsultation: false,
        aggregateRating: 4.7,
        reviewCount: 89,
        hcpcVerified: false,
        cspMember: false,
        yearsExperience: null,
        startingPrice: 45,
    },
    {
        slug: 'james-harper-jh24demo',
        type: 'individual',
        displayName: 'James Harper',
        postNominals: 'MCSP, SRP',
        headline: 'Experienced musculoskeletal physiotherapist specialising in chronic pain management and movement analysis',
        city: 'Birmingham',
        region: 'West Midlands',
        country: 'United Kingdom',
        primarySpecialty: 'Chronic Pain',
        specialties: ['Chronic Pain', 'Movement Analysis', 'Arthritis'],
        conditionsTreated: ['Chronic Pain', 'Arthritis', 'Fibromyalgia'],
        consultationTypes: ['Online', 'In-Person'],
        treatmentApproaches: ['Acupuncture', 'Manual Therapy', 'Exercise Therapy'],
        acceptedPaymentMethods: ['Private', 'Insurance', 'NHS'],
        acceptedInsurers: ['Aviva', 'Vitality'],
        gender: 'Male',
        acceptingNewPatients: true,
        availableEvenings: true,
        availableWeekends: true,
        freeConsultation: false,
        aggregateRating: 4.8,
        reviewCount: 64,
        hcpcVerified: true,
        cspMember: true,
        yearsExperience: 10,
        startingPrice: 40,
    },
    {
        slug: 'active-health-clinic-ah24demo',
        type: 'company',
        displayName: 'Active Health Clinic',
        postNominals: null,
        headline: 'Multi-disciplinary MSK clinic offering physiotherapy, sports therapy, and rehabilitation services',
        city: 'Edinburgh',
        region: 'Scotland',
        country: 'United Kingdom',
        primarySpecialty: 'General MSK',
        specialties: ['Sports Therapy', 'Rehabilitation', 'Occupational Health'],
        conditionsTreated: ['ACL Recovery', 'Ankle Sprains', 'Knee Injuries'],
        consultationTypes: ['In-Person'],
        treatmentApproaches: ['Manual Therapy', 'Hydrotherapy', 'Exercise Therapy'],
        acceptedPaymentMethods: ['Private', 'Insurance', 'Corporate'],
        acceptedInsurers: ['BUPA', 'Cigna'],
        gender: null,
        acceptingNewPatients: true,
        availableEvenings: false,
        availableWeekends: false,
        freeConsultation: false,
        aggregateRating: 4.6,
        reviewCount: 203,
        hcpcVerified: false,
        cspMember: false,
        yearsExperience: null,
        startingPrice: 30,
    },
    {
        slug: 'aisha-patel-ap24demo',
        type: 'individual',
        displayName: 'Dr Aisha Patel',
        postNominals: 'PhD, MCSP',
        headline: 'Specialist in women\'s health physiotherapy and running biomechanics with a focus on injury prevention',
        city: 'Bristol',
        region: 'South West',
        country: 'United Kingdom',
        primarySpecialty: 'Women\'s Health',
        specialties: ['Running Biomechanics', 'Pregnancy MSK', 'Pelvic Health'],
        conditionsTreated: ['Plantar Fasciitis', 'Hip Pain', 'Pelvic Floor'],
        consultationTypes: ['Online'],
        treatmentApproaches: ['Pilates', 'Exercise Therapy'],
        acceptedPaymentMethods: ['Private', 'Insurance'],
        acceptedInsurers: ['AXA Health', 'WPA'],
        gender: 'Female',
        acceptingNewPatients: true,
        availableEvenings: true,
        availableWeekends: true,
        freeConsultation: true,
        aggregateRating: 4.9,
        reviewCount: 91,
        hcpcVerified: true,
        cspMember: true,
        yearsExperience: 12,
        startingPrice: 45,
    },
    {
        slug: 'peak-performance-pp24demo',
        type: 'company',
        displayName: 'Peak Performance Physio',
        postNominals: null,
        headline: 'Elite sports physiotherapy for athletes — from grassroots to professional level across team and individual sports',
        city: 'Leeds',
        region: 'Yorkshire',
        country: 'United Kingdom',
        primarySpecialty: 'Elite Sport',
        specialties: ['Sports Injuries', 'Performance Rehab', 'Pitch-side Support'],
        conditionsTreated: ['Hamstring Injuries', 'Shin Splints', 'Tendinopathy'],
        consultationTypes: ['In-Person'],
        treatmentApproaches: ['Shockwave Therapy', 'Dry Needling', 'Manual Therapy'],
        acceptedPaymentMethods: ['Private', 'Corporate'],
        acceptedInsurers: [],
        gender: null,
        acceptingNewPatients: false,
        availableEvenings: false,
        availableWeekends: false,
        freeConsultation: false,
        aggregateRating: 4.7,
        reviewCount: 156,
        hcpcVerified: false,
        cspMember: true,
        yearsExperience: null,
        startingPrice: 50,
    },
    {
        slug: 'claire-davidson-cd24demo',
        type: 'individual',
        displayName: 'Claire Davidson',
        postNominals: 'BSc, HCPC',
        headline: 'Helping patients recover from neck, shoulder, and spinal conditions through evidence-based manual therapy and exercise',
        city: 'Glasgow',
        region: 'Scotland',
        country: 'United Kingdom',
        primarySpecialty: 'Spinal Rehabilitation',
        specialties: ['Neck Pain', 'Shoulder Recovery', 'Spinal Rehab'],
        conditionsTreated: ['Neck Pain', 'Shoulder Impingement', 'Sciatica'],
        consultationTypes: ['Online', 'In-Person', 'Home Visit'],
        treatmentApproaches: ['Manual Therapy', 'Dry Needling', 'Exercise Therapy'],
        acceptedPaymentMethods: ['Private', 'Insurance', 'NHS'],
        acceptedInsurers: ['BUPA', 'Aviva'],
        gender: 'Female',
        acceptingNewPatients: true,
        availableEvenings: true,
        availableWeekends: false,
        freeConsultation: false,
        aggregateRating: 4.8,
        reviewCount: 73,
        hcpcVerified: true,
        cspMember: false,
        yearsExperience: 8,
        startingPrice: 35,
    },
    {
        slug: 'move-better-clinic-mb24demo',
        type: 'company',
        displayName: 'Move Better Clinic',
        postNominals: null,
        headline: 'Specialist upper limb and racket sport clinic — treating elbow, wrist, and hand conditions for active people',
        city: 'Cardiff',
        region: 'Wales',
        country: 'United Kingdom',
        primarySpecialty: 'Upper Limb',
        specialties: ['Elbow Conditions', 'Wrist & Hand', 'Racket Sports'],
        conditionsTreated: ['Tennis Elbow', 'Golfer\'s Elbow', 'Wrist Pain'],
        consultationTypes: ['In-Person'],
        treatmentApproaches: ['Shockwave Therapy', 'Manual Therapy'],
        acceptedPaymentMethods: ['Private', 'Insurance'],
        acceptedInsurers: ['AXA Health', 'Vitality'],
        gender: null,
        acceptingNewPatients: true,
        availableEvenings: false,
        availableWeekends: true,
        freeConsultation: false,
        aggregateRating: 4.5,
        reviewCount: 48,
        hcpcVerified: false,
        cspMember: true,
        yearsExperience: null,
        startingPrice: 38,
    },
    */
];

// TODO: Replace with API call to /api/search-pages?type=study when real studies are published
const sampleStudies = [
    /* Coming soon — no live studies yet
    {
        slug: 'indigo-study-a1b2c3d4',
        studyAcronym: 'INDIGO',
        headline: 'Investigating Digital Interventions for Gait Optimization in Older Adults',
        status: 'recruiting',
        sponsor: 'University College London',
        piName: 'Prof. James Chen',
        piInstitution: 'UCL Institute of Sport Science',
        studyType: 'Randomized Controlled Trial',
        duration: '12 weeks',
        location: 'Remote / UK-wide',
        targetEnrollment: 200,
        currentEnrollment: 87,
    },
    {
        slug: 'motion-sense-b2c3d4e5',
        studyAcronym: 'MOTION-SENSE',
        headline: 'Monitoring Outcomes Through Intelligent Observation of Natural Sensor Data',
        status: 'recruiting',
        sponsor: 'University of Birmingham',
        piName: 'Dr Priya Sharma',
        piInstitution: 'School of Sport & Rehabilitation Sciences',
        studyType: 'Observational Cohort',
        duration: '6 months',
        location: 'Remote / UK-wide',
        targetEnrollment: 500,
        currentEnrollment: 312,
    },
    {
        slug: 'smart-rehab-c3d4e5f6',
        studyAcronym: 'SMART-REHAB',
        headline: 'Smart Wearable-Assisted Rehabilitation for Knee Replacement Recovery',
        status: 'recruiting',
        sponsor: 'Imperial College London',
        piName: 'Mr Tom Bradley',
        piInstitution: 'Department of Bioengineering',
        studyType: 'Interventional',
        duration: '16 weeks',
        location: 'London & Remote',
        targetEnrollment: 120,
        currentEnrollment: 45,
    },
    */
];

const sampleBlogPosts = blogPosts;

const filterCategories = ['Advisors', 'Research', 'Blog'];

// Extract unique values for filter options
const allInsurers = [...new Set(sampleAdvisors.flatMap(a => a.acceptedInsurers || []))].sort();

const consultationOptions = ['Online', 'In-Person', 'Home Visit'];
const paymentOptions = ['Private', 'Insurance'];
const genderOptions = ['Male', 'Female'];
const languageOptions = ['English', 'Welsh', 'Urdu', 'Punjabi', 'Bengali', 'Gujarati', 'Polish', 'Arabic', 'French', 'Spanish', 'Mandarin', 'Cantonese', 'Portuguese', 'Somali', 'Turkish'];
const religionOptions = ['Christianity', 'Islam', 'Hinduism', 'Sikhism', 'Buddhism', 'Judaism'];
const ethnicityOptions = ['White', 'Black', 'Asian', 'Mixed', 'Other'];
const sortOptions = [
    { value: 'relevant', label: 'Most Relevant' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'reviews', label: 'Most Reviews' },
    { value: 'price-low', label: 'Lowest Price' },
    { value: 'price-high', label: 'Highest Price' },
];

const ChevronIcon = ({ open }) => (
    <svg className={`sidebar-chevron ${open ? 'open' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
);

const ViewToggle = ({ viewMode, setViewMode }) => (
    <div className="directory-view-toggle">
        <button className={`view-toggle-btn ${viewMode === 'card' ? 'active' : ''}`} onClick={() => setViewMode('card')} aria-label="Card view" title="Card view">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16"><rect x="3" y="3" width="7" height="9" rx="1" strokeWidth="2" /><rect x="14" y="3" width="7" height="9" rx="1" strokeWidth="2" /><rect x="3" y="15" width="7" height="6" rx="1" strokeWidth="2" /><rect x="14" y="15" width="7" height="6" rx="1" strokeWidth="2" /></svg>
        </button>
        <button className={`view-toggle-btn ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')} aria-label="Compact grid view" title="Compact grid">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16"><rect x="3" y="3" width="5" height="5" rx="1" strokeWidth="2" /><rect x="10" y="3" width="5" height="5" rx="1" strokeWidth="2" /><rect x="17" y="3" width="4" height="5" rx="1" strokeWidth="2" /><rect x="3" y="10" width="5" height="5" rx="1" strokeWidth="2" /><rect x="10" y="10" width="5" height="5" rx="1" strokeWidth="2" /><rect x="17" y="10" width="4" height="5" rx="1" strokeWidth="2" /><rect x="3" y="17" width="5" height="4" rx="1" strokeWidth="2" /><rect x="10" y="17" width="5" height="4" rx="1" strokeWidth="2" /><rect x="17" y="17" width="4" height="4" rx="1" strokeWidth="2" /></svg>
        </button>
        <button className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')} aria-label="List view" title="List view">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16"><path strokeLinecap="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
    </div>
);

const SubscribePage = () => {
    const [activeCategories, setActiveCategories] = useState(['Advisors']);
    const [searchQuery, setSearchQuery] = useState('');
    const [viewMode, setViewMode] = useState('card');

    // Filter state
    const [sortBy, setSortBy] = useState('relevant');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [filterConsultation, setFilterConsultation] = useState(['Online']);
    const [filterPayment, setFilterPayment] = useState(['Private']);
    const [activeInsurer, setActiveInsurer] = useState('');
    const [acceptingOnly, setAcceptingOnly] = useState(false);
    const [freeConsultOnly, setFreeConsultOnly] = useState(false);
    const [eveningsOnly, setEveningsOnly] = useState(false);
    const [weekendsOnly, setWeekendsOnly] = useState(false);
    const [activeGender, setActiveGender] = useState('');
    const [activeLanguage, setActiveLanguage] = useState('');
    const [activeReligion, setActiveReligion] = useState('');
    const [activeEthnicity, setActiveEthnicity] = useState('');
    const [lgbtqFriendly, setLgbtqFriendly] = useState(false);
    const [disabilityAccessible, setDisabilityAccessible] = useState(false);
    const [savedAdvisors, setSavedAdvisors] = useState(() => {
        try { return JSON.parse(localStorage.getItem('savedAdvisors') || '[]'); }
        catch { return []; }
    });

    const toggleCategory = (category) => {
        setActiveCategories(prev => {
            if (prev.includes(category)) {
                if (prev.length === 1) return prev; // prevent deselecting all
                return prev.filter(c => c !== category);
            }
            return [...prev, category];
        });
    };

    const showAdvisors = activeCategories.includes('Advisors');
    const showResearch = activeCategories.includes('Research');
    const showBlog = activeCategories.includes('Blog');
    const multiCategoryView = activeCategories.length > 1;

    // Collapsible sidebar sections
    const [openSections, setOpenSections] = useState({
        consultation: false,
        availability: false,
        payment: false,
        language: false,
        preference: false,
    });

    const toggleSection = (section) => {
        setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const toggleChip = (arr, setArr, value) => {
        setArr(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
    };

    const isDefaultFilters = filterConsultation.length === 1 && filterConsultation[0] === 'Online'
        && filterPayment.length === 1 && filterPayment[0] === 'Private'
        && !activeInsurer && !acceptingOnly && !freeConsultOnly && !eveningsOnly && !weekendsOnly
        && !activeGender && !activeLanguage && !activeReligion && !activeEthnicity
        && !lgbtqFriendly && !disabilityAccessible && sortBy === 'relevant';
    const activeFilterCount = [
        sortBy !== 'relevant',
        filterConsultation.length > 0,
        filterPayment.length > 0,
        activeInsurer,
        acceptingOnly,
        freeConsultOnly,
        eveningsOnly,
        weekendsOnly,
        activeGender,
        activeLanguage,
        activeReligion,
        activeEthnicity,
        lgbtqFriendly,
        disabilityAccessible,
    ].filter(Boolean).length;

    const hasActiveFilters = searchQuery || !isDefaultFilters;

    const clearAllFilters = () => {
        setSearchQuery('');
        setSortBy('relevant');
        setFilterConsultation([]);
        setFilterPayment([]);
        setActiveInsurer('');
        setAcceptingOnly(false);
        setFreeConsultOnly(false);
        setEveningsOnly(false);
        setWeekendsOnly(false);
        setActiveGender('');
        setActiveLanguage('');
        setActiveReligion('');
        setActiveEthnicity('');
        setLgbtqFriendly(false);
        setDisabilityAccessible(false);
    };

    // Build active filter pills for display
    const activeFilterPills = [];
    filterConsultation.forEach(ct => activeFilterPills.push({ label: ct, key: `ct-${ct}`, onClear: () => setFilterConsultation(prev => prev.filter(v => v !== ct)) }));
    filterPayment.forEach(pm => activeFilterPills.push({ label: pm, key: `pm-${pm}`, onClear: () => setFilterPayment(prev => prev.filter(v => v !== pm)) }));
    if (activeInsurer) activeFilterPills.push({ label: activeInsurer, key: 'ins', onClear: () => setActiveInsurer('') });
    if (acceptingOnly) activeFilterPills.push({ label: 'Accepting patients', key: 'accepting', onClear: () => setAcceptingOnly(false) });
    if (freeConsultOnly) activeFilterPills.push({ label: 'Free consultation', key: 'free', onClear: () => setFreeConsultOnly(false) });
    if (eveningsOnly) activeFilterPills.push({ label: 'Evenings', key: 'eve', onClear: () => setEveningsOnly(false) });
    if (weekendsOnly) activeFilterPills.push({ label: 'Weekends', key: 'wknd', onClear: () => setWeekendsOnly(false) });
    if (activeGender) activeFilterPills.push({ label: activeGender, key: 'gender', onClear: () => setActiveGender('') });
    if (activeLanguage) activeFilterPills.push({ label: activeLanguage, key: 'language', onClear: () => setActiveLanguage('') });
    if (activeReligion) activeFilterPills.push({ label: activeReligion, key: 'religion', onClear: () => setActiveReligion('') });
    if (activeEthnicity) activeFilterPills.push({ label: activeEthnicity, key: 'ethnicity', onClear: () => setActiveEthnicity('') });
    if (lgbtqFriendly) activeFilterPills.push({ label: 'LGBTQ+ experienced', key: 'lgbtq', onClear: () => setLgbtqFriendly(false) });
    if (disabilityAccessible) activeFilterPills.push({ label: 'Disability experienced', key: 'disability', onClear: () => setDisabilityAccessible(false) });
    if (sortBy !== 'relevant') activeFilterPills.push({ label: sortOptions.find(o => o.value === sortBy)?.label || sortBy, key: 'sort', onClear: () => setSortBy('relevant') });

    // Compute which filter sections have data from actual advisors
    const hasGenderData = sampleAdvisors.some(a => a.gender);
    const hasLanguageData = sampleAdvisors.some(a => a.languages && a.languages.length > 0);
    const hasReligionData = sampleAdvisors.some(a => a.religionExperience && a.religionExperience.length > 0);
    const hasEthnicityData = sampleAdvisors.some(a => a.ethnicityExperience && a.ethnicityExperience.length > 0);
    const hasLgbtqData = sampleAdvisors.some(a => a.lgbtqFriendly);
    const hasDisabilityData = sampleAdvisors.some(a => a.disabilityAccessible);
    const hasBackgroundData = hasGenderData || hasReligionData || hasEthnicityData || hasLgbtqData || hasDisabilityData;

    // Filter advisors
    const filteredAdvisors = sampleAdvisors.filter(advisor => {
        if (filterConsultation.length > 0 && !filterConsultation.some(ct => (advisor.consultationTypes || []).includes(ct))) return false;
        if (filterPayment.length > 0 && !filterPayment.some(pm => (advisor.acceptedPaymentMethods || []).includes(pm))) return false;
        if (activeInsurer && !(advisor.acceptedInsurers || []).includes(activeInsurer)) return false;
        if (acceptingOnly && !advisor.acceptingNewPatients) return false;
        if (freeConsultOnly && !advisor.freeConsultation) return false;
        if (eveningsOnly && !advisor.availableEvenings) return false;
        if (weekendsOnly && !advisor.availableWeekends) return false;
        if (activeGender && advisor.gender !== activeGender) return false;
        if (searchQuery) {
            const q = searchQuery.toLowerCase();
            const searchable = [
                advisor.displayName,
                advisor.headline,
                advisor.city,
                advisor.region,
                advisor.primarySpecialty,
                ...(advisor.specialties || []),
                ...(advisor.conditionsTreated || []),
                ...(advisor.consultationTypes || []),
                ...(advisor.treatmentApproaches || []),
            ].join(' ').toLowerCase();
            if (!searchable.includes(q)) return false;
        }
        return true;
    });

    // Sort advisors
    const sortedAdvisors = [...filteredAdvisors].sort((a, b) => {
        switch (sortBy) {
            case 'rating': return (b.aggregateRating || 0) - (a.aggregateRating || 0);
            case 'reviews': return (b.reviewCount || 0) - (a.reviewCount || 0);
            case 'price-low': return (a.startingPrice || 999) - (b.startingPrice || 999);
            case 'price-high': return (b.startingPrice || 0) - (a.startingPrice || 0);
            default: return 0;
        }
    });

    // Filter research studies by search query
    const filteredStudies = sampleStudies.filter(study => {
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase();
        return [study.studyAcronym, study.headline, study.sponsor, study.piName, study.piInstitution, study.location]
            .join(' ').toLowerCase().includes(q);
    });

    // Filter blog posts by search query
    const filteredBlogPosts = sampleBlogPosts.filter(post => {
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase();
        return [post.title, post.excerpt, post.author, post.category]
            .join(' ').toLowerCase().includes(q);
    });

    const toggleSave = (e, slug) => {
        e.preventDefault();
        e.stopPropagation();
        setSavedAdvisors(prev => {
            const updated = prev.includes(slug) ? prev.filter(s => s !== slug) : [...prev, slug];
            localStorage.setItem('savedAdvisors', JSON.stringify(updated));
            return updated;
        });
    };

    useEffect(() => {
        document.title = 'Find an Advisor | PhysioActivity';
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute('content', 'Browse qualified MSK professionals, active research studies, and expert insights. Subscribe directly to an advisor or explore research opportunities.');
    }, []);

    const getInitials = (name) => {
        if (!name) return '?';
        return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    };

    // Shared sidebar content (used in both desktop aside and mobile drawer)
    const sidebarContent = (
        <>
            <div className="sidebar-header">
                <h3>Filters</h3>
                <button className="sidebar-clear" onClick={clearAllFilters}>Clear all</button>
            </div>

            {/* Consultation */}
            <div className="sidebar-section">
                <button className="sidebar-section-toggle" onClick={() => toggleSection('consultation')}>
                    <span>Consultation</span>
                    <ChevronIcon open={openSections.consultation} />
                </button>
                {openSections.consultation && (
                    <div className="sidebar-section-content">
                        <div className="filter-chips">
                            {consultationOptions.map(opt => (
                                <button key={opt} className={`filter-chip ${filterConsultation.includes(opt) ? 'active' : ''}`} onClick={() => toggleChip(filterConsultation, setFilterConsultation, opt)}>{opt}</button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* Availability */}
            <div className="sidebar-section">
                <button className="sidebar-section-toggle" onClick={() => toggleSection('availability')}>
                    <span>Availability</span>
                    <ChevronIcon open={openSections.availability} />
                </button>
                {openSections.availability && (
                    <div className="sidebar-section-content">
                        <label className="filter-toggle"><input type="checkbox" checked={acceptingOnly} onChange={(e) => setAcceptingOnly(e.target.checked)} /><span>Accepting patients</span></label>
                        <label className="filter-toggle"><input type="checkbox" checked={eveningsOnly} onChange={(e) => setEveningsOnly(e.target.checked)} /><span>Evenings</span></label>
                        <label className="filter-toggle"><input type="checkbox" checked={weekendsOnly} onChange={(e) => setWeekendsOnly(e.target.checked)} /><span>Weekends</span></label>
                        <label className="filter-toggle"><input type="checkbox" checked={freeConsultOnly} onChange={(e) => setFreeConsultOnly(e.target.checked)} /><span>Free consultation</span></label>
                    </div>
                )}
            </div>

            {/* Payment & Insurance */}
            <div className="sidebar-section">
                <button className="sidebar-section-toggle" onClick={() => toggleSection('payment')}>
                    <span>Payment & Insurance</span>
                    <ChevronIcon open={openSections.payment} />
                </button>
                {openSections.payment && (
                    <div className="sidebar-section-content">
                        <div className="filter-chips">
                            {paymentOptions.map(opt => (
                                <button key={opt} className={`filter-chip ${filterPayment.includes(opt) ? 'active' : ''}`} onClick={() => toggleChip(filterPayment, setFilterPayment, opt)}>{opt}</button>
                            ))}
                        </div>
                        <select className="filter-select" value={activeInsurer} onChange={(e) => setActiveInsurer(e.target.value)} style={{ marginTop: '0.5rem' }}>
                            <option value="">All Insurers</option>
                            {allInsurers.map(ins => (
                                <option key={ins} value={ins}>{ins}</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            {/* Language — only show if advisors have language data */}
            {hasLanguageData && (
                <div className="sidebar-section">
                    <button className="sidebar-section-toggle" onClick={() => toggleSection('language')}>
                        <span>Language</span>
                        <ChevronIcon open={openSections.language} />
                    </button>
                    {openSections.language && (
                        <div className="sidebar-section-content">
                            <select className="filter-select" value={activeLanguage} onChange={(e) => setActiveLanguage(e.target.value)}>
                                <option value="">Any</option>
                                {languageOptions.map(l => <option key={l} value={l}>{l}</option>)}
                            </select>
                        </div>
                    )}
                </div>
            )}

            {/* Patient Background — only show if advisors have background data */}
            {hasBackgroundData && (
                <div className="sidebar-section">
                    <button className="sidebar-section-toggle" onClick={() => toggleSection('preference')}>
                        <span>Background</span>
                        <ChevronIcon open={openSections.preference} />
                    </button>
                    {openSections.preference && (
                        <div className="sidebar-section-content">
                            <p className="filter-hint">Find clinicians experienced with patients from your background</p>
                            {hasGenderData && (<>
                                <label className="filter-label">Practitioner gender</label>
                                <select className="filter-select" value={activeGender} onChange={(e) => setActiveGender(e.target.value)}>
                                    <option value="">Any</option>
                                    {genderOptions.map(g => <option key={g} value={g}>{g}</option>)}
                                </select>
                            </>)}
                            {hasReligionData && (<>
                                <label className="filter-label">Faith community experience</label>
                                <select className="filter-select" value={activeReligion} onChange={(e) => setActiveReligion(e.target.value)}>
                                    <option value="">Any</option>
                                    {religionOptions.map(r => <option key={r} value={r}>{r}</option>)}
                                </select>
                            </>)}
                            {hasEthnicityData && (<>
                                <label className="filter-label">Cultural background experience</label>
                                <select className="filter-select" value={activeEthnicity} onChange={(e) => setActiveEthnicity(e.target.value)}>
                                    <option value="">Any</option>
                                    {ethnicityOptions.map(eth => <option key={eth} value={eth}>{eth}</option>)}
                                </select>
                            </>)}
                            {hasLgbtqData && (
                                <label className="filter-toggle" style={{ marginTop: '0.5rem' }}><input type="checkbox" checked={lgbtqFriendly} onChange={(e) => setLgbtqFriendly(e.target.checked)} /><span>LGBTQ+ experienced</span></label>
                            )}
                            {hasDisabilityData && (
                                <label className="filter-toggle"><input type="checkbox" checked={disabilityAccessible} onChange={(e) => setDisabilityAccessible(e.target.checked)} /><span>Disability experienced</span></label>
                            )}
                        </div>
                    )}
                </div>
            )}
        </>
    );

    const advisorCard = (advisor) => (
        <Link to={`/profile/${advisor.slug}`} key={advisor.slug} className={`advisor-card ${viewMode === 'list' ? 'advisor-card-list' : viewMode === 'grid' ? 'advisor-card-compact' : ''}`}>
            {viewMode === 'list' ? (
                /* ---- List view: horizontal row ---- */
                <>
                    <div className="advisor-list-avatar">
                        {getInitials(advisor.displayName)}
                    </div>
                    <div className="advisor-list-info">
                        <h3 className="advisor-card-name">
                            {advisor.displayName}
                            {advisor.postNominals && <span className="advisor-card-postnominals">{advisor.postNominals}</span>}
                        </h3>
                        <p className="advisor-card-headline">{advisor.headline}</p>
                        <div className="advisor-list-meta">
                            <span className="advisor-card-location">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                                {advisor.city}, {advisor.country}
                            </span>
                            {advisor.consultationTypes && advisor.consultationTypes.map(ct => (
                                <span key={ct} className={`consultation-chip ${ct === 'Online' ? 'online' : ct === 'Home Visit' ? 'home' : 'in-person'}`}>{ct}</span>
                            ))}
                            {advisor.hcpcVerified && <span className="badge verified">HCPC</span>}
                            {advisor.freeConsultation && <span className="badge free-consult">Free consult</span>}
                        </div>
                    </div>
                    <div className="advisor-list-right">
                        <div className="advisor-card-status">
                            {advisor.acceptingNewPatients ? (
                                <span className="status-accepting"><span className="status-dot accepting" />Accepting</span>
                            ) : (
                                <span className="status-full"><span className="status-dot full" />Full</span>
                            )}
                        </div>
                        {advisor.aggregateRating && (
                            <div className="advisor-card-rating">
                                <span className="rating-stars">{'★'.repeat(Math.floor(advisor.aggregateRating))}</span>
                                <span className="rating-count">({advisor.reviewCount})</span>
                            </div>
                        )}
                        {advisor.startingPrice && <div className="advisor-card-pricing">From £{advisor.startingPrice}/mo</div>}
                        <button
                            className={`advisor-save-btn ${savedAdvisors.includes(advisor.slug) ? 'saved' : ''}`}
                            onClick={(e) => toggleSave(e, advisor.slug)}
                            aria-label={savedAdvisors.includes(advisor.slug) ? 'Remove from shortlist' : 'Save to shortlist'}
                        >
                            <svg viewBox="0 0 24 24" width="16" height="16" fill={savedAdvisors.includes(advisor.slug) ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
                                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
                            </svg>
                        </button>
                    </div>
                </>
            ) : viewMode === 'grid' ? (
                /* ---- Compact grid view ---- */
                <>
                    <div className="advisor-compact-header">
                        <div className="advisor-compact-avatar">{getInitials(advisor.displayName)}</div>
                        <button
                            className={`advisor-save-btn ${savedAdvisors.includes(advisor.slug) ? 'saved' : ''}`}
                            onClick={(e) => toggleSave(e, advisor.slug)}
                            aria-label={savedAdvisors.includes(advisor.slug) ? 'Remove from shortlist' : 'Save to shortlist'}
                        >
                            <svg viewBox="0 0 24 24" width="14" height="14" fill={savedAdvisors.includes(advisor.slug) ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
                                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
                            </svg>
                        </button>
                    </div>
                    <h3 className="advisor-card-name">{advisor.displayName}</h3>
                    <div className="advisor-card-location">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                        {advisor.city}
                    </div>
                    <div className="advisor-card-footer">
                        {advisor.aggregateRating && (
                            <div className="advisor-card-rating">
                                <span className="rating-stars">{'★'.repeat(Math.floor(advisor.aggregateRating))}</span>
                                <span className="rating-count">({advisor.reviewCount})</span>
                            </div>
                        )}
                        {advisor.startingPrice && <div className="advisor-card-pricing">£{advisor.startingPrice}/mo</div>}
                    </div>
                </>
            ) : (
                /* ---- Default card view ---- */
                <>
                    <div className="advisor-card-cover">
                        <div className="advisor-card-photo">
                            {getInitials(advisor.displayName)}
                        </div>
                        <button
                            className={`advisor-save-btn ${savedAdvisors.includes(advisor.slug) ? 'saved' : ''}`}
                            onClick={(e) => toggleSave(e, advisor.slug)}
                            aria-label={savedAdvisors.includes(advisor.slug) ? 'Remove from shortlist' : 'Save to shortlist'}
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill={savedAdvisors.includes(advisor.slug) ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2">
                                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
                            </svg>
                        </button>
                    </div>
                    <div className="advisor-card-body">
                        <h3 className="advisor-card-name">
                            {advisor.displayName}
                            {advisor.postNominals && (
                                <span className="advisor-card-postnominals">{advisor.postNominals}</span>
                            )}
                        </h3>
                        <p className="advisor-card-headline">{advisor.headline}</p>
                        <div className="advisor-card-location">
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            {advisor.city}, {advisor.country}
                        </div>
                        {advisor.consultationTypes && advisor.consultationTypes.length > 0 && (
                            <div className="advisor-card-consultation">
                                {advisor.consultationTypes.map(ct => (
                                    <span key={ct} className={`consultation-chip ${ct === 'Online' ? 'online' : ct === 'Home Visit' ? 'home' : 'in-person'}`}>{ct}</span>
                                ))}
                            </div>
                        )}
                        {advisor.specialties && advisor.specialties.length > 0 && (
                            <div className="advisor-card-specialties">
                                {advisor.specialties.slice(0, 3).map((spec) => (
                                    <span key={spec} className="specialty-tag">{spec}</span>
                                ))}
                            </div>
                        )}
                        <div className="advisor-card-badges">
                            {advisor.hcpcVerified && (<span className="badge verified">HCPC Registered</span>)}
                            {advisor.cspMember && (<span className="badge">CSP Member</span>)}
                            {advisor.yearsExperience && (<span className="badge">{advisor.yearsExperience}+ years</span>)}
                            {advisor.freeConsultation && (<span className="badge free-consult">Free consult</span>)}
                        </div>
                        <div className="advisor-card-status">
                            {advisor.acceptingNewPatients ? (
                                <span className="status-accepting"><span className="status-dot accepting" />Accepting patients</span>
                            ) : (
                                <span className="status-full"><span className="status-dot full" />Not taking patients</span>
                            )}
                        </div>
                        <div className="advisor-card-footer">
                            {advisor.aggregateRating && (
                                <div className="advisor-card-rating">
                                    <span className="rating-stars">{'★'.repeat(Math.floor(advisor.aggregateRating))}</span>
                                    <span className="rating-count">({advisor.reviewCount})</span>
                                </div>
                            )}
                            {advisor.startingPrice && (
                                <div className="advisor-card-pricing">From £{advisor.startingPrice}/mo</div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </Link>
    );

    return (
        <div className="directory-page">
            {/* Hero */}
            <div className="directory-hero">
                <div className="directory-hero-content">
                    <div className="directory-hero-icon">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>
                    <h1 className="directory-hero-title">Discover Advisors & Research</h1>
                    <p className="directory-hero-subtitle">
                        Browse qualified MSK professionals, active research studies, and expert insights from the world of musculoskeletal health
                    </p>
                </div>
            </div>

            <div className="directory-container">
                {/* Toolbar */}
                <div className="directory-toolbar">
                    <div className="directory-toolbar-tabs">
                        {filterCategories.map((category) => (
                            <button
                                key={category}
                                className={`directory-filter-btn ${activeCategories.includes(category) ? 'active' : ''}`}
                                onClick={() => toggleCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                    <div className="directory-toolbar-search">
                        <div className="directory-search-input-wrap">
                            <svg className="directory-search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                type="text"
                                className="directory-search-input"
                                placeholder="Search advisors, studies, articles..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <button className="directory-search-clear" onClick={() => setSearchQuery('')} aria-label="Clear search">&times;</button>
                            )}
                        </div>
                        {showAdvisors && (
                            <select className="directory-toolbar-sort" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                                {sortOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                            </select>
                        )}
                        {/* Mobile-only filter drawer trigger (Advisors only) */}
                        {showAdvisors && (
                            <button className="directory-mobile-filter-btn" onClick={() => setSidebarOpen(true)}>
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                                </svg>
                                Filters
                                {activeFilterCount > 0 && <span className="filter-count-badge">{activeFilterCount}</span>}
                            </button>
                        )}
                    </div>
                    <ViewToggle viewMode={viewMode} setViewMode={setViewMode} />
                </div>

                {/* Content sections — multi-select: sidebar layout when Advisors active */}
                {showAdvisors ? (
                    <div className="directory-layout">
                        {/* Desktop sidebar */}
                        <aside className="directory-sidebar directory-sidebar-desktop">
                            {sidebarContent}
                        </aside>

                        {/* Mobile drawer */}
                        {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
                        <aside className={`directory-sidebar directory-sidebar-mobile ${sidebarOpen ? 'open' : ''}`}>
                            <div className="sidebar-mobile-header">
                                <h3>Filters</h3>
                                <button className="sidebar-mobile-close" onClick={() => setSidebarOpen(false)} aria-label="Close filters">&times;</button>
                            </div>
                            {sidebarContent}
                            <div className="sidebar-mobile-footer">
                                <button className="sidebar-mobile-apply" onClick={() => setSidebarOpen(false)}>
                                    Show {sortedAdvisors.length} result{sortedAdvisors.length !== 1 ? 's' : ''}
                                </button>
                            </div>
                        </aside>

                        {/* Main content area */}
                        <div className="directory-main">
                            {/* Active Filter Pills */}
                            {activeFilterPills.length > 0 && (
                                <div className="directory-active-pills">
                                    {activeFilterPills.map(pill => (
                                        <button key={pill.key} className="active-pill" onClick={pill.onClear}>
                                            {pill.label}
                                            <span className="active-pill-x">&times;</span>
                                        </button>
                                    ))}
                                    {!isDefaultFilters && <button className="active-pill-clear" onClick={clearAllFilters}>Clear all</button>}
                                    <span className="active-pill-count">{sortedAdvisors.length} result{sortedAdvisors.length !== 1 ? 's' : ''}</span>
                                </div>
                            )}

                            {/* Advisors */}
                            {multiCategoryView && <h3 className="directory-section-heading">Advisors</h3>}
                            {sortedAdvisors.length > 0 ? (
                                <div className={`directory-grid view-${viewMode}`}>
                                    {sortedAdvisors.map(advisor => advisorCard(advisor))}
                                </div>
                            ) : (
                                <div className="directory-coming-soon">
                                    <div className="directory-coming-soon-icon">
                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <h2>Coming Soon</h2>
                                    <p>We're onboarding qualified MSK advisors. Browse the filters to see how the directory will work. Check back soon for live profiles.</p>
                                    <div className="directory-coming-soon-actions">
                                        <Link to="/physiotherapists" className="cta-button">Join as an Advisor</Link>
                                    </div>
                                </div>
                            )}

                            {/* Research (inside sidebar layout) */}
                            {showResearch && (
                                <>
                                    {multiCategoryView && <h3 className="directory-section-heading">Research Studies</h3>}
                                    {filteredStudies.length > 0 ? (
                                        <div className={`directory-grid view-${viewMode}`}>
                                            {filteredStudies.map((study) => {
                                                const enrollPct = study.targetEnrollment > 0 ? Math.round((study.currentEnrollment / study.targetEnrollment) * 100) : 0;
                                                return (
                                                    <Link to={`/research/${study.slug}`} key={study.slug} className="research-card">
                                                        <div className="research-card-header">
                                                            <span className="research-card-acronym">{study.studyAcronym}</span>
                                                            <span className={`research-card-status ${study.status}`}>{study.status.charAt(0).toUpperCase() + study.status.slice(1)}</span>
                                                        </div>
                                                        <h3 className="research-card-headline">{study.headline}</h3>
                                                        <div className="research-card-pi">
                                                            <div className="research-card-pi-avatar">{getInitials(study.piName)}</div>
                                                            <div className="research-card-pi-info">
                                                                <span className="research-card-pi-name">{study.piName}</span>
                                                                <span className="research-card-pi-institution">{study.piInstitution}</span>
                                                            </div>
                                                        </div>
                                                        <div className="research-card-meta">
                                                            <span>{study.studyType}</span>
                                                            <span>{study.duration}</span>
                                                            <span>{study.location}</span>
                                                        </div>
                                                        <div className="research-card-progress">
                                                            <div className="progress-bar"><div className="progress-fill" style={{ width: `${enrollPct}%` }} /></div>
                                                            <span className="progress-text">{study.currentEnrollment} / {study.targetEnrollment} participants</span>
                                                        </div>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="directory-empty">
                                            {searchQuery ? (
                                                <><p>No research studies match "{searchQuery}".</p><button className="directory-filter-btn active" onClick={() => setSearchQuery('')}>Clear search</button></>
                                            ) : (
                                                <div className="directory-coming-soon-inline"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="28" height="28"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg><p>Research studies coming soon.</p></div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}

                            {/* Blog (inside sidebar layout) */}
                            {showBlog && (
                                <>
                                    {multiCategoryView && <h3 className="directory-section-heading">Blog</h3>}
                                    {filteredBlogPosts.length > 0 ? (
                                        <div className={`directory-grid view-${viewMode}`}>
                                            {filteredBlogPosts.map((post) => (
                                                <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-dir-card">
                                                    <div className="blog-dir-card-image">
                                                        <span className="blog-dir-category-tag">{post.category}</span>
                                                    </div>
                                                    <div className="blog-dir-card-body">
                                                        <h3 className="blog-dir-card-title">{post.title}</h3>
                                                        <p className="blog-dir-card-excerpt">{post.excerpt}</p>
                                                        <div className="blog-dir-card-meta">
                                                            <div className="blog-dir-avatar">{getInitials(post.author)}</div>
                                                            <div className="blog-dir-meta-info">
                                                                <span className="blog-dir-author-name">{post.author}</span>
                                                                <span className="blog-dir-meta-details">{formatDate(post.date)} &middot; {post.readTime} read</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="directory-empty">
                                            {searchQuery ? (
                                                <><p>No blog posts match "{searchQuery}".</p><button className="directory-filter-btn active" onClick={() => setSearchQuery('')}>Clear search</button></>
                                            ) : (
                                                <div className="directory-coming-soon-inline"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="28" height="28"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg><p>Blog posts coming soon.</p></div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ) : (
                    /* No Advisors selected — full-width layout for Research/Blog only */
                    <div className="directory-full-width">
                        {showResearch && (
                            <>
                                {multiCategoryView && <h3 className="directory-section-heading">Research Studies</h3>}
                                {filteredStudies.length > 0 ? (
                                    <div className={`directory-grid view-${viewMode}`}>
                                        {filteredStudies.map((study) => {
                                            const enrollPct = study.targetEnrollment > 0 ? Math.round((study.currentEnrollment / study.targetEnrollment) * 100) : 0;
                                            return (
                                                <Link to={`/research/${study.slug}`} key={study.slug} className="research-card">
                                                    <div className="research-card-header">
                                                        <span className="research-card-acronym">{study.studyAcronym}</span>
                                                        <span className={`research-card-status ${study.status}`}>{study.status.charAt(0).toUpperCase() + study.status.slice(1)}</span>
                                                    </div>
                                                    <h3 className="research-card-headline">{study.headline}</h3>
                                                    <div className="research-card-pi">
                                                        <div className="research-card-pi-avatar">{getInitials(study.piName)}</div>
                                                        <div className="research-card-pi-info">
                                                            <span className="research-card-pi-name">{study.piName}</span>
                                                            <span className="research-card-pi-institution">{study.piInstitution}</span>
                                                        </div>
                                                    </div>
                                                    <div className="research-card-meta">
                                                        <span>{study.studyType}</span>
                                                        <span>{study.duration}</span>
                                                        <span>{study.location}</span>
                                                    </div>
                                                    <div className="research-card-progress">
                                                        <div className="progress-bar"><div className="progress-fill" style={{ width: `${enrollPct}%` }} /></div>
                                                        <span className="progress-text">{study.currentEnrollment} / {study.targetEnrollment} participants</span>
                                                    </div>
                                                </Link>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="directory-empty">
                                        {searchQuery ? (
                                            <><p>No research studies match "{searchQuery}".</p><button className="directory-filter-btn active" onClick={() => setSearchQuery('')}>Clear search</button></>
                                        ) : (
                                            <p>No research studies listed yet. Check back soon.</p>
                                        )}
                                    </div>
                                )}
                            </>
                        )}

                        {showBlog && (
                            <>
                                {multiCategoryView && <h3 className="directory-section-heading">Blog</h3>}
                                {filteredBlogPosts.length > 0 ? (
                                    <div className={`directory-grid view-${viewMode}`}>
                                        {filteredBlogPosts.map((post) => (
                                            <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-dir-card">
                                                <div className="blog-dir-card-image">
                                                    <span className="blog-dir-category-tag">{post.category}</span>
                                                </div>
                                                <div className="blog-dir-card-body">
                                                    <h3 className="blog-dir-card-title">{post.title}</h3>
                                                    <p className="blog-dir-card-excerpt">{post.excerpt}</p>
                                                    <div className="blog-dir-card-meta">
                                                        <div className="blog-dir-avatar">{getInitials(post.author)}</div>
                                                        <div className="blog-dir-meta-info">
                                                            <span className="blog-dir-author-name">{post.author}</span>
                                                            <span className="blog-dir-meta-details">{formatDate(post.date)} &middot; {post.readTime} read</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="directory-empty">
                                        {searchQuery ? (
                                            <><p>No blog posts match "{searchQuery}".</p><button className="directory-filter-btn active" onClick={() => setSearchQuery('')}>Clear search</button></>
                                        ) : (
                                            <p>No blog posts yet. Check back soon.</p>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}

                {/* Disclaimer */}
                <section className="disclaimer-section">
                    <div className="disclaimer-container">
                        <h3>Disclaimer</h3>
                        <p>This platform provides supplementary guidance and is not a replacement for seeking care through traditional healthcare pathways such as the NHS, your GP, or emergency services. If you are experiencing serious pain, injury, or medical concerns, please contact your healthcare provider or visit your local A&E department. In case of emergency, always call 999.</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SubscribePage;
